import React, { useState } from 'react';
import {getProduct} from '../../services/products'
import Header from "../header";
import Body from "../body";
import Footer from "../footer";

const Product = (props) => {
    console.log(props.match.params)
    const [product, setProduct] = useState(getProduct(props.match.params.productSlug));
    return ( 
        <React.Fragment>
            <Header product={product} />
            <Body product={product} />
            <Footer product={product} />
        </React.Fragment>
     );
}
 
export default Product;